import { useOutletContext } from 'react-router-dom';

type ModelContext = {
  isGrid: boolean;
};

export const useModelContext = () => useOutletContext<ModelContext>();
